<template>
  <AppNav />
  <router-view/>
  <AppFoot/>
</template>

<script>
import AppFoot from './navfot/appFoot.vue'
// import HelloWorld from './components/HelloWorld.vue'
import AppNav from './navfot/appNav.vue'

export default {
  name: 'App',
  components: {
    AppNav,
    AppFoot,
  },
}
</script>

